// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kVKO","rootMobile":"styles_rootMobile__2ktEZ"};